import { useEffect, useRef, useState } from "react";
import MobileBottomMenu from "../../Components/MobileBottomMenu";
import MobileHeaderSection from "../../Components/MobileHeaderSection";
import MobileLeftSection from "../../Components/MobileLeftSection";
import Slider from "react-slick";
import { materialdet } from "../../Action/materialAction";
import { useDispatch } from "react-redux";
import Lock from "../../Components/Lock";

export default function MobileCourseMaterial({
  detailsMatertial,
  MaterialList,
}) {
  const [SideOpener, setSideOpner] = useState(false);
  const materialsRef = useRef();
  const [ShowMore, setShowMore] = useState(false);
  const [SelectDetails, setSelectDetails] = useState(
    MaterialList && MaterialList?.length ? MaterialList[0] : {}
  );
  const MaterialConfig = {
    dots: false,
    infinite: false,
    autoplay: false,
    speed: 600,
    gap: 6,
    slidesToShow: 2,
    slidesToScroll: 1,
  };
  const dispatch = useDispatch();
  const OpenSideMenu = (e) => {
    setSideOpner(!SideOpener);
  };

  useEffect(() => {
    if (MaterialList?.length) {
      setSelectDetails(MaterialList[0]);
      dispatch(materialdet(MaterialList[0]?.SubTitle[0]?.materialSubTitleId));
    }
  }, [MaterialList]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className="Mobile_View_css">
        <div
          onClick={OpenSideMenu}
          className={SideOpener ? "menu-overlay active" : "menu-overlay"}
          id="menuOverlay"
        ></div>
        <MobileLeftSection SideOpener={SideOpener} Page="Material" />
        <div className="main-content">
          <MobileHeaderSection Page="Materials" OpenSideMenu={OpenSideMenu} />
          <div className="page-content" id="materialsPage">
            {/* <!-- Materials Header --> */}
            {MaterialList && MaterialList?.length ? (
              <>
                <section className="materials-header">
                  <div className="materials-tabs">
                    <Slider
                      ref={materialsRef}
                      style={{ width: "100%" }}
                      {...MaterialConfig}
                    >
                      {MaterialList?.map((ev, i) => (
                        <div>
                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              setSelectDetails({ ...ev });
                              dispatch(materialdet(ev?.materialSubTitleId));
                              // setShowMore("");
                            }}
                            key={i + 457}
                            className={
                              SelectDetails?._id == ev?._id
                                ? "tab-btn active"
                                : "tab-btn"
                            }
                          >
                            {ev?.materialTitle}
                          </button>
                        </div>
                      ))}
                    </Slider>
                  </div>
                </section>

                {/* <!-- Materials Content --> */}
                <section className="materials-content">
                  {/* <div
                    className=" mt"
                    // style={ShowMore ? { height: "auto" } : { height: "80px" }}
                  >
                    {SelectDetails?.SubTitle?.map((ev, i) => (
                      <div
                        key={i + 905}
                        className={
                          ShowMore == ev?.materialSubTitle
                            ? "nav-item2 active"
                            : "nav-item2"
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          setShowMore(ev?.materialSubTitle);

                          dispatch(materialdet(ev?.materialSubTitleId));
                        }}
                      >
                        <span>{ev?.materialSubTitle}</span>
                        {ShowMore == ev?.materialSubTitle ? (
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <polyline points="6,9 12,15 18,9" />
                          </svg>
                        ) : (
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                          >
                            <polyline points="9,18 15,12 9,6" />
                          </svg>
                        )}
                      </div>
                    ))}
                  </div> */}

                  <div style={{ width: "100%" }}>
                    <select
                      className="mt"
                      onChange={(ev) => {
                        // console.log("kl", ev?.target);
                        // setShowMore(ev?.target.value?.materialSubTitle);
                        dispatch(materialdet(ev?.target.value));
                      }}
                      style={{
                        width: "100%",
                        paddingRight: "10px",
                        height: "35px",
                      }}
                    >
                      {SelectDetails?.SubTitle?.map((ev, i) => (
                        <option
                          value={ev?.materialSubTitleId}
                          key={ev?._id}
                          style={
                            ShowMore == ev?.materialSubTitle
                              ? { color: "#2C3F8C" }
                              : { color: "black" }
                          }
                        >
                          {ev?.materialSubTitle}
                        </option>
                      ))}
                    </select>
                  </div>
                  {/* <div>
                  {ShowMore ? (
                    <></>
                  ) : (
                    <svg
                      width="93"
                      height="20"
                      viewBox="0 0 93 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.95064 7.76456C5.91371 7.39216 5.75521 7.10286 5.47514 6.89666C5.19508 6.69046 4.81499 6.58736 4.33487 6.58736C4.00864 6.58736 3.73319 6.63352 3.50852 6.72585C3.28385 6.8151 3.11151 6.93975 2.99148 7.09979C2.87453 7.25982 2.81605 7.44141 2.81605 7.64453C2.8099 7.8138 2.84529 7.96153 2.92223 8.08771C3.00225 8.2139 3.11151 8.32315 3.25 8.41548C3.38849 8.50473 3.54853 8.58321 3.73011 8.65092C3.9117 8.71555 4.10559 8.77095 4.31179 8.81712L5.16122 9.02024C5.57363 9.11257 5.95218 9.23568 6.29688 9.38956C6.64157 9.54344 6.9401 9.73272 7.19247 9.95739C7.44484 10.1821 7.64027 10.4467 7.77876 10.7514C7.92034 11.0561 7.99266 11.4054 7.99574 11.7994C7.99266 12.378 7.84493 12.8796 7.55256 13.3043C7.26326 13.726 6.8447 14.0537 6.29688 14.2876C5.75213 14.5185 5.09505 14.6339 4.32564 14.6339C3.56238 14.6339 2.89761 14.5169 2.33132 14.283C1.76811 14.0491 1.32801 13.7029 1.01101 13.2443C0.697088 12.7827 0.532434 12.2118 0.517045 11.5316H2.45135C2.47289 11.8486 2.56368 12.1133 2.72372 12.3256C2.88684 12.5349 3.10381 12.6934 3.37464 12.8011C3.64856 12.9058 3.95786 12.9581 4.30256 12.9581C4.6411 12.9581 4.93501 12.9089 5.1843 12.8104C5.43667 12.7119 5.6321 12.5749 5.7706 12.3995C5.90909 12.2241 5.97834 12.0225 5.97834 11.7947C5.97834 11.5824 5.91525 11.4039 5.78906 11.2592C5.66596 11.1146 5.48438 10.9915 5.24432 10.8899C5.00734 10.7884 4.7165 10.696 4.3718 10.6129L3.34233 10.3544C2.54522 10.1605 1.91584 9.85736 1.45419 9.44496C0.992543 9.03255 0.763258 8.47704 0.766335 7.77841C0.763258 7.20597 0.915601 6.70585 1.22337 6.27805C1.53421 5.85026 1.96046 5.51634 2.50213 5.27628C3.0438 5.03622 3.65933 4.91619 4.34872 4.91619C5.05043 4.91619 5.66288 5.03622 6.18608 5.27628C6.71236 5.51634 7.12169 5.85026 7.41406 6.27805C7.70644 6.70585 7.85724 7.20135 7.86648 7.76456H5.95064ZM11.27 10.4006V14.5H9.30336V5.04545H11.2146V8.66016H11.2977C11.4577 8.2416 11.7162 7.91383 12.0732 7.67685C12.4302 7.43679 12.878 7.31676 13.4166 7.31676C13.9091 7.31676 14.3384 7.42448 14.7046 7.63991C15.074 7.85227 15.3602 8.1585 15.5633 8.55859C15.7695 8.95561 15.8711 9.43111 15.868 9.98508V14.5H13.9014V10.3359C13.9044 9.89891 13.7936 9.55883 13.569 9.3157C13.3474 9.07256 13.0365 8.95099 12.6365 8.95099C12.3687 8.95099 12.1317 9.00793 11.9255 9.1218C11.7224 9.23568 11.5624 9.40187 11.4454 9.62038C11.3315 9.83582 11.2731 10.0959 11.27 10.4006ZM20.6195 14.6385C19.9024 14.6385 19.2823 14.4862 18.7591 14.1815C18.2389 13.8737 17.8373 13.4459 17.5542 12.8981C17.271 12.3472 17.1294 11.7086 17.1294 10.9822C17.1294 10.2498 17.271 9.60961 17.5542 9.06179C17.8373 8.51089 18.2389 8.0831 18.7591 7.77841C19.2823 7.47064 19.9024 7.31676 20.6195 7.31676C21.3366 7.31676 21.9552 7.47064 22.4753 7.77841C22.9985 8.0831 23.4017 8.51089 23.6848 9.06179C23.968 9.60961 24.1096 10.2498 24.1096 10.9822C24.1096 11.7086 23.968 12.3472 23.6848 12.8981C23.4017 13.4459 22.9985 13.8737 22.4753 14.1815C21.9552 14.4862 21.3366 14.6385 20.6195 14.6385ZM20.6287 13.1151C20.955 13.1151 21.2273 13.0227 21.4458 12.8381C21.6644 12.6503 21.829 12.3949 21.9398 12.0717C22.0537 11.7486 22.1106 11.3808 22.1106 10.9684C22.1106 10.556 22.0537 10.1882 21.9398 9.86506C21.829 9.5419 21.6644 9.28646 21.4458 9.09872C21.2273 8.91098 20.955 8.81712 20.6287 8.81712C20.2994 8.81712 20.0224 8.91098 19.7978 9.09872C19.5762 9.28646 19.4084 9.5419 19.2946 9.86506C19.1838 10.1882 19.1284 10.556 19.1284 10.9684C19.1284 11.3808 19.1838 11.7486 19.2946 12.0717C19.4084 12.3949 19.5762 12.6503 19.7978 12.8381C20.0224 13.0227 20.2994 13.1151 20.6287 13.1151ZM26.6094 14.5L24.6797 7.40909H26.6694L27.7681 12.1733H27.8327L28.9776 7.40909H30.9304L32.0938 12.1456H32.1538L33.234 7.40909H35.2191L33.294 14.5H31.212L29.9933 10.0405H29.9055L28.6868 14.5H26.6094ZM39.3139 5.04545H41.7791L44.3828 11.3977H44.4936L47.0973 5.04545H49.5625V14.5H47.6236V8.34624H47.5451L45.0984 14.4538H43.7781L41.3313 8.32315H41.2528V14.5H39.3139V5.04545ZM54.3763 14.6385C53.6592 14.6385 53.0391 14.4862 52.5159 14.1815C51.9958 13.8737 51.5941 13.4459 51.311 12.8981C51.0278 12.3472 50.8863 11.7086 50.8863 10.9822C50.8863 10.2498 51.0278 9.60961 51.311 9.06179C51.5941 8.51089 51.9958 8.0831 52.5159 7.77841C53.0391 7.47064 53.6592 7.31676 54.3763 7.31676C55.0934 7.31676 55.712 7.47064 56.2322 7.77841C56.7554 8.0831 57.1585 8.51089 57.4417 9.06179C57.7248 9.60961 57.8664 10.2498 57.8664 10.9822C57.8664 11.7086 57.7248 12.3472 57.4417 12.8981C57.1585 13.4459 56.7554 13.8737 56.2322 14.1815C55.712 14.4862 55.0934 14.6385 54.3763 14.6385ZM54.3856 13.1151C54.7118 13.1151 54.9842 13.0227 55.2027 12.8381C55.4212 12.6503 55.5858 12.3949 55.6966 12.0717C55.8105 11.7486 55.8675 11.3808 55.8675 10.9684C55.8675 10.556 55.8105 10.1882 55.6966 9.86506C55.5858 9.5419 55.4212 9.28646 55.2027 9.09872C54.9842 8.91098 54.7118 8.81712 54.3856 8.81712C54.0563 8.81712 53.7793 8.91098 53.5546 9.09872C53.333 9.28646 53.1653 9.5419 53.0514 9.86506C52.9406 10.1882 52.8852 10.556 52.8852 10.9684C52.8852 11.3808 52.9406 11.7486 53.0514 12.0717C53.1653 12.3949 53.333 12.6503 53.5546 12.8381C53.7793 13.0227 54.0563 13.1151 54.3856 13.1151ZM59.1452 14.5V7.40909H61.0518V8.64631H61.1256C61.2549 8.2062 61.4719 7.87382 61.7765 7.64915C62.0812 7.4214 62.4321 7.30753 62.8291 7.30753C62.9276 7.30753 63.0338 7.31368 63.1476 7.32599C63.2615 7.3383 63.3615 7.35523 63.4477 7.37678V9.1218C63.3554 9.0941 63.2277 9.06948 63.0645 9.04794C62.9014 9.0264 62.7522 9.01562 62.6167 9.01562C62.3274 9.01562 62.0689 9.07872 61.8412 9.2049C61.6165 9.32801 61.438 9.50035 61.3057 9.72195C61.1764 9.94354 61.1118 10.199 61.1118 10.4883V14.5H59.1452ZM67.3659 14.6385C66.6365 14.6385 66.0087 14.4908 65.4824 14.1953C64.9592 13.8968 64.556 13.4751 64.2729 12.9304C63.9898 12.3826 63.8482 11.7347 63.8482 10.9869C63.8482 10.2575 63.9898 9.61731 64.2729 9.06641C64.556 8.51551 64.9546 8.08617 65.4686 7.77841C65.9856 7.47064 66.5919 7.31676 67.2875 7.31676C67.7553 7.31676 68.1908 7.39216 68.5939 7.54297C69.0002 7.6907 69.3541 7.91383 69.6557 8.21236C69.9604 8.51089 70.1974 8.88636 70.3667 9.33878C70.5359 9.78812 70.6206 10.3144 70.6206 10.9176V11.4577H64.633V10.239H68.7694C68.7694 9.95585 68.7078 9.70502 68.5847 9.48651C68.4616 9.26799 68.2908 9.09718 68.0723 8.97408C67.8568 8.84789 67.606 8.7848 67.3198 8.7848C67.0212 8.7848 66.7566 8.85405 66.5257 8.99254C66.298 9.12796 66.1195 9.31108 65.9902 9.5419C65.861 9.76965 65.7948 10.0236 65.7917 10.3036V11.4624C65.7917 11.8132 65.8564 12.1164 65.9856 12.3718C66.118 12.6272 66.3042 12.8242 66.5442 12.9627C66.7843 13.1012 67.069 13.1705 67.3983 13.1705C67.6168 13.1705 67.8168 13.1397 67.9984 13.0781C68.18 13.0166 68.3354 12.9242 68.4647 12.8011C68.5939 12.678 68.6924 12.5272 68.7601 12.3487L70.579 12.4688C70.4867 12.9058 70.2974 13.2874 70.0112 13.6136C69.728 13.9368 69.3618 14.1892 68.9125 14.3707C68.4662 14.5492 67.9507 14.6385 67.3659 14.6385Z"
                        fill="#2C3F8C"
                      />
                      <path
                        d="M82.2012 14V6H83.7929V14H82.2012ZM79 10.7929V9.20118H87V10.7929H79Z"
                        fill="#2C3F8C"
                      />
                    </svg>
                  )}
                </div> */}

                  {/* <div className="materials-nav">
                  <div className="nav-item active">
                    <span>IELTS Introduction</span>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <polyline points="6,9 12,15 18,9" />
                    </svg>
                  </div>

                  <div className="nav-item">
                    <span>IELTS Introduction</span>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <polyline points="9,18 15,12 9,6" />
                    </svg>
                  </div>
                </div> */}

                  <div className="material-detail">
                    <h3>{ShowMore}</h3>
                    <div
                      className="DangeriousTextFrame2"
                      dangerouslySetInnerHTML={{
                        __html: detailsMatertial?.MaterialDescription,
                      }}
                    ></div>
                  </div>
                </section>
              </>
            ) : (
              <div style={{ padding: "20px" }}>
                <Lock />
              </div>
            )}
          </div>
          <MobileBottomMenu Page="Materials" />
        </div>
      </div>
    </>
  );
}
